//packages
import React, { Component } from 'react';
import PropTypes from 'prop-types';

//styles
import './InfoMessage.less'

class InfoMessage extends Component {
    static propTypes = {
        children: PropTypes.oneOfType([
            PropTypes.element,
            PropTypes.array,
            PropTypes.string,
            PropTypes.number,
        ])
    };

    static defaultProps = {
        children: '',
    };

    render() {
        return (
            <div className="info-message">{this.props.children}</div>
        );
    }

}

export default InfoMessage



/** WEBPACK FOOTER **
 ** ./src/components/Modules/InfoMessage/InfoMessage.js
 **/